export const TINY_EXPERIENCE_TRACKING_FF =
	'confluence.frontend.tiny.experience.reintroduce-tracking';
